export const TICKET_HISTORY_UPDATE_STATE = "TICKET_HISTORY_UPDATE_STATE"
export const TICKETLOGS_LOADED = "TICKETLOGS_LOADED"
export const UPDATE_SELECTED_TICKET = "UPDATE_SELECTED_TICKET"
export const MORE_TICKETLOGS_LOADED = "MORE_TICKETLOGS_LOADED"
export const UPDATE_TICKET_LIVE_CHATS = "UPDATE_TICKET_LIVE_CHATS"
export const REMOVE_TICKET_LIVE_CHATS = "REMOVE_TICKET_LIVE_CHATS"
export const REMOVE_LIVE_CHATS_ON_SELECTION = "REMOVE_LIVE_CHATS_ON_SELECTION"
